import { FileBadge, KeyRound, ShieldCheck } from 'lucide-react';
import AvisosYConservacion from '../cumplimiento/AvisosYConservacion';
import CustodiaDelSello from '../cumplimiento/CustodiaDelSello';
import MisDatos from '../cumplimiento/MisDatos';

/* =====================================================================
   Las pantallas del carril `cumplimiento` · F5, F6, F8, F9
   =====================================================================
   «Mis datos» va junto a «Mi cuenta» (grupo Tu cuenta, orden 6, justo
   después de seguridad), para cualquiera con sesión. Lo del dueño va en
   un grupo propio, «Cumplimiento», al final.
   ===================================================================== */
export default {
  orden: 6,
  grupos: [
    {
      grupo: 'Tu cuenta',
      items: [
        { id: 'cumplimiento-mis-datos', etiqueta: 'Mis datos', icono: ShieldCheck, min: 'CONSULTA', Comp: MisDatos },
      ],
    },
    {
      grupo: 'Cumplimiento',
      items: [
        { id: 'cumplimiento-avisos', etiqueta: 'Avisos y conservación', icono: FileBadge, min: 'DUENO', Comp: AvisosYConservacion },
        { id: 'cumplimiento-custodia', etiqueta: 'Quién guarda el sello fiscal', icono: KeyRound, min: 'DUENO', Comp: CustodiaDelSello },
      ],
    },
  ],
};
